import { ActionTree } from 'vuex'
import { AuthState, IAuthState } from './state';
import { authTypes } from './types';

export const authActions: ActionTree<AuthState, IAuthState> = {
  async [authTypes.actions.setAuth]({ commit }, authInfo) {
    commit(authTypes.mutations.updateAuthState, authInfo.isAuthenticated);
    commit(authTypes.mutations.updateUserInfo, authInfo.userInfo);
  },

  async [authTypes.actions.setAppSettings]({ commit }, settings) {
    commit(authTypes.mutations.updateAppSettings, settings);
  },
};
